module.exports = __webpack_public_path__ + "static/media/bills-multiple-upload.e51ea92b.svg";